export default class SimpleOrganizationDto {
    /**
     * @type{number}
     */
    ogId;

    /**
     * @type{string}
     */
    ogName;
}
